import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';
import addTravelPlan from '../../mutations/RepVisitsTravelPlan/addTravelPlan';
import Community from './community';

const query = gql`
  query CommunityOverviewPage {
    viewer {
      id
      firstName
      lastName
      uuid
      email
      institution {
        id
        name
        field_country
      }
    }
  }
`;

const graphqlData = graphql(query);
const mutation = graphql(addTravelPlan, { name: 'addTravelPlan' });

export default SimpleLoadingComponent(graphqlData, mutation)(Community);
